import { render, staticRenderFns } from "./ScientificDegreesGrid.vue?vue&type=template&id=a4e9c4e0"
import script from "./ScientificDegreesGrid.vue?vue&type=script&lang=js"
export * from "./ScientificDegreesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports